import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { UserCircle, Building2 } from "lucide-react";
import { toast } from "sonner";

export default function SelectRole() {
  const { user, setRole, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!user) { navigate("/login"); return null; }

  const choose = async (role) => {
    try {
      await setRole(role);
      toast.success(`Welcome! Setting up your ${role} account.`);
      navigate(role === "candidate" ? "/candidate/profile" : "/employer/dashboard", { replace: true });
    } catch {
      toast.error("Could not set role");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 hero-grid px-4">
      <div className="max-w-2xl w-full">
        <h1 className="font-display text-3xl font-bold text-center text-slate-900 mb-2">How do you want to use CableCareer?</h1>
        <p className="text-center text-slate-500 mb-10">Choose your account type to get started.</p>
        <div className="grid md:grid-cols-2 gap-5">
          <button data-testid="role-candidate" onClick={() => choose("candidate")} className="group bg-white p-8 rounded-2xl border-2 border-slate-200 hover:border-[#D96B27] transition-all text-left shadow-sm hover:shadow-lg">
            <div className="w-14 h-14 rounded-xl bg-[#FFF3EC] flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <UserCircle className="w-8 h-8 text-[#D96B27]" />
            </div>
            <h3 className="font-display text-xl font-bold text-slate-900">I'm a Candidate</h3>
            <p className="text-sm text-slate-500 mt-2">Build an industry profile, upload your resume and apply to specialized cable & conductor jobs.</p>
          </button>
          <button data-testid="role-employer" onClick={() => choose("employer")} className="group bg-white p-8 rounded-2xl border-2 border-slate-200 hover:border-[#D96B27] transition-all text-left shadow-sm hover:shadow-lg">
            <div className="w-14 h-14 rounded-xl bg-slate-100 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <Building2 className="w-8 h-8 text-slate-700" />
            </div>
            <h3 className="font-display text-xl font-bold text-slate-900">I'm an Employer</h3>
            <p className="text-sm text-slate-500 mt-2">Post jobs, search specialized technical talent and manage applications for your plant.</p>
          </button>
        </div>
      </div>
    </div>
  );
}
